const num = (v) => {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

const qtyOf = (line) => ({
  ordered: num(line?.orderedQty ?? line?.orderedQuantity ?? line?.quantity),
  received: num(line?.receivedQty ?? line?.receivedQuantity),
})

const looksLikeLine = (row) =>
  !!row &&
  (row.orderedQty != null ||
    row.orderedQuantity != null ||
    row.receivedQty != null ||
    row.receivedQuantity != null ||
    row.quantity != null)

// GET /purchases/{id}/grn has shipped as either one receipt (`{ lines }`) or
// a list of receipts. Both field names used by the goods-receipt screens are
// accepted so the badge doesn't depend on which shape comes back.
const asReceipts = (data) => {
  if (!data) return []
  if (Array.isArray(data)) {
    if (!data.length) return []
    if (data[0]?.lines || data[0]?.receiptLines) return data
    if (looksLikeLine(data[0])) return [{ lines: data }]
    return data
  }
  if (Array.isArray(data.lines)) return [data]
  if (Array.isArray(data.grns)) return data.grns
  if (Array.isArray(data.items)) return asReceipts(data.items)
  return []
}

const lineKey = (line, index) => line?.orderRequestLineId ?? line?.lineId ?? line?.itemId ?? line?.id ?? `line-${index}`

export const summarizeGoodsReceipt = (data) => {
  const byLine = new Map()
  asReceipts(data).forEach((receipt) => {
    const lines = receipt?.lines || receipt?.receiptLines || []
    lines.forEach((line, index) => {
      const key = lineKey(line, index)
      const q = qtyOf(line)
      const current = byLine.get(key)
      if (!current) {
        byLine.set(key, { ordered: q.ordered, received: q.received })
        return
      }
      current.received += q.received
      if (!current.ordered && q.ordered) current.ordered = q.ordered
    })
  })

  const rows = [...byLine.values()]
  if (!rows.length) {
    return { tone: "danger", label: "Not Received", detail: "No receipt", empty: true }
  }
  const ordered = rows.reduce((sum, row) => sum + row.ordered, 0)
  const received = rows.reduce((sum, row) => sum + row.received, 0)
  const detail = `${received}/${ordered} items`
  if (ordered > 0 && received >= ordered) return { tone: "ok", label: "Received", detail, empty: false }
  if (received <= 0) return { tone: "danger", label: "Not Received", detail, empty: false }
  return { tone: "warn", label: "Partially Received", detail, empty: false }
}
